// extracted by mini-css-extract-plugin
export default {"container":"ExitTacticSection_container__sOilf"};